// Since: cosmos-sdk 0.43

// @generated by protoc-gen-es v1.0.0 with parameter "rewrite_imports=./tendermint/version/**/*_pb.js:@buf/tendermint_tendermint.bufbuild_es,rewrite_imports=./tendermint/types/**/*_pb.js:@buf/tendermint_tendermint.bufbuild_es,rewrite_imports=./tendermint/p2p/**/*_pb.js:@buf/tendermint_tendermint.bufbuild_es,rewrite_imports=./tendermint/crypto/**/*_pb.js:@buf/tendermint_tendermint.bufbuild_es,rewrite_imports=./tendermint/abci/**/*_pb.js:@buf/tendermint_tendermint.bufbuild_es,rewrite_imports=./google/api/**/*_pb.js:@buf/googleapis_googleapis.bufbuild_es,rewrite_imports=./gogoproto/**/*_pb.js:@buf/cosmos_gogo-proto.bufbuild_es,rewrite_imports=./cosmos_proto/**/*_pb.js:@buf/cosmos_cosmos-proto.bufbuild_es"
// @generated from file cosmos/authz/v1beta1/authz.proto (package cosmos.authz.v1beta1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { Any, proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * GenericAuthorization gives the grantee unrestricted permissions to execute
 * the provided method on behalf of the granter's account.
 *
 * @generated from message cosmos.authz.v1beta1.GenericAuthorization
 */
export const GenericAuthorization = proto3.makeMessageType(
  "cosmos.authz.v1beta1.GenericAuthorization",
  () => [
    { no: 1, name: "msg", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Grant gives permissions to execute
 * the provide method with expiration time.
 *
 * @generated from message cosmos.authz.v1beta1.Grant
 */
export const Grant = proto3.makeMessageType(
  "cosmos.authz.v1beta1.Grant",
  () => [
    { no: 1, name: "authorization", kind: "message", T: Any },
    { no: 2, name: "expiration", kind: "message", T: Timestamp },
  ],
);

/**
 * GrantAuthorization extends a grant with both the addresses of the grantee and granter.
 * It is used in genesis.proto and query.proto
 *
 * @generated from message cosmos.authz.v1beta1.GrantAuthorization
 */
export const GrantAuthorization = proto3.makeMessageType(
  "cosmos.authz.v1beta1.GrantAuthorization",
  () => [
    { no: 1, name: "granter", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "grantee", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "authorization", kind: "message", T: Any },
    { no: 4, name: "expiration", kind: "message", T: Timestamp },
  ],
);

/**
 * GrantQueueItem contains the list of TypeURL of a sdk.Msg.
 *
 * @generated from message cosmos.authz.v1beta1.GrantQueueItem
 */
export const GrantQueueItem = proto3.makeMessageType(
  "cosmos.authz.v1beta1.GrantQueueItem",
  () => [
    { no: 1, name: "msg_type_urls", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

